/**
 * Types for Bulk Edit Dialog
 */
export const BULK_EDIT_STEPS = {
    SELECT_DISTRIBUTOR: "select-distributor",
    SELECT_OBJECTIVE: "select-objective",
    EDIT_FIELDS: "edit-fields",
    REVIEW_CHANGES: "review-changes",
    CONFIRMATION: "confirmation",
    LOADING: "loading",
    RESULT: "result",
};
export const BULK_EDIT_STEPS_LIST = Object.values(BULK_EDIT_STEPS);
// export interface BulkEditRow {
//   delegacion_zona_de_ventas: string;
//   fields: Record<string, string>;
// }
// export interface BulkEditResponse {
//   success: boolean;
//   affectedRows: number;
//   message?: string;
//   errors?: string[];
// }
